import { render, staticRenderFns } from "./NetworkSelector.vue?vue&type=template&id=2b1abc74&scoped=true&"
import script from "./NetworkSelector.vue?vue&type=script&lang=js&"
export * from "./NetworkSelector.vue?vue&type=script&lang=js&"
import style0 from "./NetworkSelector.vue?vue&type=style&index=0&id=2b1abc74&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b1abc74",
  null
  
)

export default component.exports